import { getFormByFormId } from '../services/formServices';
import {
    initSessionWatch,
    sessionWatchWidgetClosed,
    sessionWatchWidgetOpened,
} from '../utils/sessionWatch';
import { t, tDefault } from '../utils/i18n';
import { applyDisclaimerFooters } from '../utils/disclaimerFooter';
import { getLeadResumeToken } from '../services/selectTimeService';
import {
    APPOINTMENT_CHANNEL_ID,
    APPOINTMENT_REQUEST_CALENDAR,
    HOST_TYPE_ONE_ON_ONE,
    HOST_TYPE_ROUND_ROBIN,
    HOST_TYPE_COLLECTIVE,
    BOOK_APPOINTMENT_PARAM,
    DROPOFF_RESUME_PARAM,
    ESTIMATE,
    ESTIMATE_ID_PARAM,
    EVENT_ID_PARAM,
    EVENT_MESSAGE,
    FULL_PAGE,
    HIDE,
    HIDE_WIDGET,
    IGNORE_IFRAME,
    IS_LOAD_INSTANCE_QUOTE,
    SCREEN,
    UPDATE_APPOINTMENT_CHANNEL,
    UPLOAD_ID_PARAM,
    APPOINTMENT_REQUEST_FORM,
} from '../utils/constants';
import {
    locations,
    primaryColor,
    procedures,
    providers,
    setAppUrl,
    setCategories,
    setForm,
    setFormId,
    setLocations,
    setInterests,
    setOriginProcedures,
    setOriginProviders,
    setPhoneToCall,
    setPrimaryColor,
    setProcedures,
    setProviders,
    setWebAssistantOptions,
    setOptionNames,
    setWidgetOptions,
    setProcedureSelectionType,
    form,
    sourceParam,
    setVisitorId,
    pagesDom,
    isInInstantQuote,
    isBookAppointment,
    selectedProcedures,
    setOptionIcons,
    setTooltip,
    setFileUploadChannel,
    setFinancing,
    setConsultationNonSurgicalPath,
    setBusinessName,
    setA2pConsentEnabled,
    setShowMaleFemalePage,
    setStaffProcedures,
    setHidePricing,
    setShowBodyAreaSelection,
    setRedirectUrl,
    setCalendarRedirectUrl,
    isModalPopup,
    setIsModalPopup,
    staffId,
    setStaffId,
    setProjectId,
    setAccessToken,
    appUrl,
    setSelectedLocation,
    setPicture,
    setProcedureIdSelected,
    setIsDesktopVer,
    setAppointmentChannelId,
    formId,
    appointmentChannelId,
    setShowSubscribedToOffersOption,
    setSkipInterestPage,
    setHideFutureSpecialsOptIn,
    providerId,
    setIsDisableSearchService,
    selectedLocation,
    setIsHideServiceDuration,
    setHiddenPages,
    visitorId,
    setShouldCollectPatientInfoFirstForWidget,
    shouldCollectPatientInfoFirstForWidget,
    setIsFlowForCalendar,
    hiddenPages,
    isFlowForCalendar,
    setSelectedProcedures,
    setInitUI,
    setQuestionsForAppointment,
    tempLeadInfo,
    setTempLeadInfo,
    leadInfo,
    setIsInstantQuote,
    setLeadInfo,
    setLeadTextId,
    locationId,
    skipInterestPage,
    setSelectedLanguage,
    isAutoSelectSoonestProviderEnabled,
} from '../utils/variables';
import { loadLocationsDropdown } from '../views/components/locationsDropdown';
import { onLoadOption } from '../views/components/menu';
import { loadProvidersDropdown } from '../views/components/providersDropdown';
import { loadSelectSearchProcedure } from '../views/components/selectSearchProcedure';
import { loadAskQuestionComponents } from '../views/pages/askQuestion';
import { loadLocationList } from '../views/pages/locations';
import { loadInterestList } from '../views/pages/interests';
import { loadRequestConsultComponents } from '../views/pages/sheduleConsult';
import { loadInstantQuotes } from '../views/pages/instantQuote';
import { loadSurgicalList } from '../views/pages/surgical';
import { setLoadingColor, toggleLoadingIframe } from './actions/loading';
import { askQuestionListeners } from './events/askQuestionListeners';
import { bindEvent } from './events/assistantListeners';
import { scheduleListeners, handelConsultSummaryBtn } from './events/consultListeners';
import { filterCategory } from './events/filterCategory';
import { footerListeners } from './events/footerListeners';
import { handleLocationPage, locationListeners } from './events/locationListeners';
import { interestListeners } from './events/interestListeners';
import { fullNameListeners } from './events/fullNameListeners';
import { emailListeners } from './events/emailListeners';
import { surgicalListeners } from './events/surgicalListeners';
import { instantQuoteSummaryListeners } from './events/instantQuoteSummaryListeners';
import { validateDigitsListeners } from './events/validateDigitsListeners';
import {
    navigate,
    openAskQuestion,
    openBookAppointment,
    openInstantQuote,
    openScheduleConsultation,
    openWidget,
    pageListeners,
    params,
    refresh,
} from './events/movePages';
import { consultSchedulingListeners } from './events/consultSchedulingListeners';
import { handleProviderContinueBtn, providerListeners, handleSelectProvider } from './events/providersListeners';
import { createVisitor, updateVisitorAction } from '../services/visitorServices';
import {
    getProceduresStaffByProcedureIds,
} from '../services/procedureServices';
import { handleInstantQuoteSummary } from './events/instantQuoteSummaryListeners';
import { toastError } from '../views/components/error';
import { createLead } from '../services/leadServices';
import { toggleLoading } from './actions/loading';
import { loadUploadPhotosLandingPage } from './actions/uploadPhotosActions';
import { loadInstantQuoteSummaryLandingPage } from './actions/instantQuoteSummaryActions';
import { loadAppoinmentConfirmedLandingPage } from './actions/appointmentConfirmedActions';
import { bookAppointmentListeners } from './events/bookAppointmentListeners';
import { loadCategories } from '../views/components/category';
import { loadProcedures } from '../views/components/procedures';
import { loadProviderList } from '../views/pages/providers';
import { renderContinueBtn } from './actions/providerActions';
import { urlPrefill } from '../utils/urlPrefill';

let buttonTriggered = '';

window.onload = async () => {
    window.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
            e.preventDefault();
        }

        if (e.key === 'Escape' && params('modal-popup')) {
            /* Send `message` to the parent */
            parent.postMessage('close_modal_popup', "*");
        }
    });

    setAppUrl(params('appUrl'));
    setPrimaryColor('#' + params('color'));
    setStaffId(params('staff_id') ?? 0);
    setProcedureIdSelected(params('procedure_id') ?? 0);

    /* Set primary color */
    document.body.style.setProperty('--primary-color', primaryColor);

    const formIdParam = params('form_id') || params('form');
    if (formIdParam) {
        setFormId(formIdParam);
    }
    const form = await getFormByFormId(formIdParam, params('appointment_channel_id'), params('path') || null);

    // Whitelabel branding: hide PilotPractice references when project has whitelabel enabled
    const projectWhitelabel = form?.data?.project?.whitelabel ?? false;
    if (projectWhitelabel) {
        // Hide "Powered by PilotPractice"
        document.querySelectorAll('.subFooter--4').forEach((el) => {
            el.innerHTML = '';
        });
        // Terms/Privacy links: point to project website instead of pilotpractice.com
        const projectWebsite = form?.data?.project?.website;
        document.querySelectorAll('.note .link').forEach((i) => {
            if (projectWebsite) {
                i.onclick = (e) => {
                    e.stopPropagation();
                    window.parent.parent.location.href = projectWebsite;
                };
            } else {
                i.style.cursor = 'default';
                i.style.textDecoration = 'none';
            }
        });
    } else {
        document.querySelectorAll('.note .link').forEach((i) => {
            i.onclick = (e) => {
                e.stopPropagation();
                window.parent.parent.location.href =
                    i.textContent === 'Terms'
                        ? 'https://pilotpractice.com/terms-and-conditions/'
                        : 'https://pilotpractice.com/privacy-policy/';
            };
        });
        var elements = document.querySelectorAll('.powered_by');
        for (var i = 0; i < elements.length; i++) {
            elements[i].innerHTML = (params('appUrl') || '').includes('kloudmd')
                ? 'KloudMD'
                : 'PilotPractice';
            const parentSpan = elements[i].closest('span');
            if (parentSpan && parentSpan.firstChild?.nodeType === Node.TEXT_NODE) {
                parentSpan.firstChild.textContent = t('powered_by') + ' ';
            }
        }
    }

    // Contact prefill handed off via URL params (e.g. kloudmd.com/get-started):
    // seed the static request-consult inputs. Assigned via .value, so inert as HTML.
    const nameConsultEl = document.querySelector('#nameConsult');
    if (nameConsultEl && !nameConsultEl.value && urlPrefill.full_name) {
        nameConsultEl.value = urlPrefill.full_name;
    }
    const emailConsultEl = document.querySelector('#emailConsult');
    if (emailConsultEl && !emailConsultEl.value && urlPrefill.email) {
        emailConsultEl.value = urlPrefill.email;
    }

    setHiddenPages(form?.data?.hidden_pages ?? []);
    if (!form.data?.hidden_pages?.includes('patient_page')) {
        if (!form.data?.appointment_channel?.patient_type_selection) {
            setHiddenPages([...hiddenPages, 'patient_page']);
        }
    }

    if (!form.data?.hidden_pages?.includes('surgical')) {
        setHiddenPages([...hiddenPages, 'surgical']);
    }

    if (params('appointment_channel_id')) {
        setAppointmentChannelId(params('appointment_channel_id'))
        const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking)

        const hostType = form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
        if (hostType === HOST_TYPE_ROUND_ROBIN && staffsOfAppointmentChannel?.length > 0) {
            const selectedStaff = staffsOfAppointmentChannel[0];
            setStaffId(selectedStaff?.id);
        } else if (hostType === HOST_TYPE_COLLECTIVE && staffsOfAppointmentChannel?.length > 0) {
            const selectedStaff = staffsOfAppointmentChannel[0];
            setStaffId(selectedStaff?.id);
        } else {
            if (staffsOfAppointmentChannel?.length === 1) {
                const staff = staffsOfAppointmentChannel[0]
                if (staff) {
                    setStaffId(staff?.id)
                }
            }
        }

        const procedure = form.data?.appointment_channel?.procedures && form.data?.appointment_channel?.procedures[0]
        if (procedure && form.data?.appointment_channel?.procedures?.length === 1) {
            setProcedureIdSelected(procedure?.id)
            setSelectedProcedures([procedure?.id])
        }
    } else {
        if (form.data?.appointment_request_type === APPOINTMENT_REQUEST_CALENDAR) {
            setAppointmentChannelId(form.data?.appointment_channel?.id)
            setShouldCollectPatientInfoFirstForWidget(true)
            setIsFlowForCalendar(true)
            const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking)

            const hostType = form.data?.appointment_channel?.host_type || HOST_TYPE_ONE_ON_ONE;
            if (hostType === HOST_TYPE_ROUND_ROBIN && staffsOfAppointmentChannel?.length > 0) {
                const selectedStaff = staffsOfAppointmentChannel[0];
                setStaffId(selectedStaff?.id);
            } else if (hostType === HOST_TYPE_COLLECTIVE && staffsOfAppointmentChannel?.length > 0) {
                const selectedStaff = staffsOfAppointmentChannel[0];
                setStaffId(selectedStaff?.id);
            } else {
                if (staffsOfAppointmentChannel?.length === 1) {
                    const staff = staffsOfAppointmentChannel && staffsOfAppointmentChannel[0]
                    if (staff) {
                        setStaffId(staff?.id)
                    }
                }
            }
            const procedure = form.data?.appointment_channel?.procedures && form.data?.appointment_channel?.procedures[0]
            if (procedure && form.data?.appointment_channel?.procedures?.length === 1) {
                setProcedureIdSelected(procedure?.id)
                setSelectedProcedures([procedure?.id])
            }
        }
    }

    if (form?.data?.default_language) {
        setSelectedLanguage(form.data.default_language);
        moment.locale(form.data.default_language);
        const titleEl = document.getElementById('main-menu-title');
        if (titleEl) titleEl.textContent = t('instant_actions');

        const staticTitles = [
            { sel: '.locations__container .title__content', key: 'get_instant_estimate' },
            { sel: '.location--title', key: 'select_location' },
            { sel: '.seeServices__container .title__content', key: 'select_services' },
            { sel: '.interests__container .title__content', key: 'get_instant_estimate' },
            { sel: '.fullNames__container .title__content', key: 'get_instant_estimate' },
            { sel: '.email__container .title__content', key: 'get_instant_estimate' },
            { sel: '.selectOnlyDate__container .selectOnlyTime__title-text', key: 'select_date_time' },
            { sel: '.selectOnlyTime__container .selectOnlyTime__title-sub', key: 'available_time' },
        ];
        staticTitles.forEach(({ sel, key }) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });

        const selectOnlyTimeSpan = document.querySelector('.selectOnlyTime__container .selectOnlyTime__title-text > span:not(.back-arrow)');
        if (selectOnlyTimeSpan) selectOnlyTimeSpan.textContent = t('select_date_time');

        // Re-apply "Powered by" translation (language is now set; the first pass runs before setSelectedLanguage)
        document.querySelectorAll('.powered_by').forEach(el => {
            const parentSpan = el.closest('span');
            if (parentSpan && parentSpan.firstChild?.nodeType === Node.TEXT_NODE) {
                parentSpan.firstChild.textContent = t('powered_by') + ' ';
            }
        });

        // Update "Continue" button text nodes in HTML
        [
            '.locationContinue__btn',
            '.procedureContinue__btn',
            '.interestContinue__btn',
            '.fullNameContinue__btn',
            '.emailContinue__btn',
            '.validateDigitsContinue__btn',
            '.register-new-patient-continue__btn',
            '.genderContinue__btn',
            '.bodySelectionContinue__btn',
            '.bookAppointmentContinue__btn',
            '.patientContinue__btn',
        ].forEach(sel => {
            document.querySelectorAll(sel).forEach(btn => {
                const textNode = Array.from(btn.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
                if (textNode) textNode.textContent = t('continue') + ' ';
            });
        });
        ['.address-collection__btn', '.ask-question-continue__btn'].forEach(sel => {
            const btn = document.querySelector(sel);
            if (btn) btn.textContent = t('continue');
        });
        const allQContinue = document.querySelector('.allQuestionsContinue__btn .text');
        if (allQContinue) allQContinue.textContent = t('continue');

        // Screen titles
        [
            ['.topQuestion__container .title__content', 'top_asked_questions'],
            ['.requestConsult__container .title__content', 'request_consult_title'],
            ['.providers__container .title__content', 'get_an_instant_estimate'],
            ['.consultScheduling__container .title__content', 'consult_scheduling'],
            ['.consultScheduling__title', 'hello_there'],
            ['.interest--title', 'when_done'],
            ['.phone__container .title__content', 'enter_phone_number'],
            ['.validateDigits__container .title__content', 'enter_otp_code'],
            ['.register-new-patient__container .title__content', 'register_as_new_patient'],
            ['.register-new-patient__header .title', 'tell_us_about_yourself'],
            ['.register-new-patient__header .subtitle', 'client_portal_info'],
            ['.instant_quote_summary__container .title__content', 'your_instant_quote'],
            ['.surgical__container .title__content', 'book_your_appointment'],
            ['.address-collection__container .title__content', 'your_address'],
            ['.appointment-summary__container .title__content', 'appointment_summary_title'],
            ['.card-collection__container .title__content', 'please_confirm_appointment'],
            ['.widgetScreen__container.instant-quote .title__content', 'instant_quote_title'],
            ['.providerScheduling__container .title__content', 'consult_scheduling'],
            ['.serviceSummary__container .title__content', 'book_your_appointment'],
            ['.askQuestion__container .title__content', 'we_will_reach_back'],
            ['.categories__container .title__content', 'select_category'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });

        // Placeholders (by ID)
        [
            ['nameConsult', 'first_last_name_placeholder'],
            ['procedureConsult', 'type_desired_service'],
            ['emailConsult', 'email_short'],
            ['phoneConsult', 'mobile_phone_placeholder'],
            ['fullName', 'full_name_short_placeholder'],
            ['email', 'email_short'],
            ['nameAskQuestion', 'first_last_name_placeholder'],
            ['emailAskQuestion', 'email_short'],
            ['phoneAskQuestion', 'mobile_phone_placeholder'],
            ['questionAskQuestion', 'whats_your_question'],
            ['addressLine1', 'address_main_placeholder'],
            ['addressLine2', 'apt_suite_placeholder'],
            ['addressCity', 'city_short'],
            ['addressState', 'state_short'],
            ['addressZip', 'zip_short'],
            ['dobDatepicker', 'select_dob'],
        ].forEach(([id, key]) => {
            const el = document.getElementById(id);
            if (el) el.placeholder = t(key);
        });

        // Register new patient placeholders (no IDs)
        const rnpInputs = document.querySelectorAll('.register-new-patient__input input:not(#dobDatepicker)');
        if (rnpInputs[0]) rnpInputs[0].placeholder = t('enter_first_name');
        if (rnpInputs[1]) rnpInputs[1].placeholder = t('enter_last_name');

        // Register new patient labels
        const rnpLabels = document.querySelectorAll('.register-new-patient__input label');
        if (rnpLabels[0]) rnpLabels[0].textContent = t('first_name');
        if (rnpLabels[1]) rnpLabels[1].textContent = t('last_name');
        if (rnpLabels[2]) rnpLabels[2].textContent = t('dob');

        // Address labels
        [
            ['addressLine1', 'street_address_label'],
            ['addressLine2', 'apt_suite_optional_label'],
            ['addressCity', 'city_short'],
            ['addressState', 'state_short'],
            ['addressZip', 'zip_code'],
        ].forEach(([forAttr, key]) => {
            const el = document.querySelector(`label[for="${forAttr}"]`);
            if (el) el.textContent = t(key);
        });

        // Field labels (class-based)
        [
            ['.fullNames--title', 'your_full_name_label'],
            ['.fullName__label', 'your_first_last_name_label'],
            ['.email--title', 'your_email_address_label'],
            ['.email__label', 'email_address_label'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });

        // Consult scheduling screen
        [
            ['.consultScheduling__subTitle', 'ready_to_schedule'],
            ['.consultScheduling__option[data-type="new-user"]', 'i_am_new_user'],
            ['.consultScheduling__option[data-type="existing-user"]', 'i_am_existing_user'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });

        // Phone screen submit button
        const phoneSubmitSpan = document.querySelector('.phoneContinue__btn span:not(.loader__icon)');
        if (phoneSubmitSpan) phoneSubmitSpan.textContent = t('submit');

        // OTP / validate digits screen (static HTML)
        const validateTitle = document.querySelector('.validateDigits--title');
        if (validateTitle) validateTitle.textContent = t('enter_4_digit_code');
        const sentToDiv = document.querySelector('.validateDigits--sub-title');
        if (sentToDiv) {
            const textNode = Array.from(sentToDiv.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = t('sent_to') + ' ';
        }
        const editPhoneBtn = document.querySelector('.edit-phone-btn');
        if (editPhoneBtn) editPhoneBtn.textContent = t('edit_btn');
        const resendU = document.querySelector('.validateDigits--resend-otp u');
        if (resendU) resendU.textContent = t('resend');

        // Instant quote screen
        const quoteTotalTitle = document.querySelector('.js-quote-total-title');
        if (quoteTotalTitle) quoteTotalTitle.textContent = t('total');
        const financingText = document.querySelector('.js-financing--text');
        if (financingText) financingText.textContent = t('as_low_as');
        const quoteTotalTitle2 = document.querySelector('.js-quote-total-title-2');
        if (quoteTotalTitle2) quoteTotalTitle2.textContent = t('total_lowercase');
        const costBreakdown = document.querySelector('.step__breakdown > span');
        if (costBreakdown) costBreakdown.textContent = t('cost_breakdown');
        const noEstimates = document.querySelector('.noEstimates');
        if (noEstimates) noEstimates.textContent = t('no_estimate_info');
        const estimateNote = document.querySelector('.summary__actions .note');
        if (estimateNote) estimateNote.textContent = t('estimate_disclaimer');
        const summaryContinueBtn = document.querySelector('.summaryContinue__btn');
        if (summaryContinueBtn) {
            const textNode = Array.from(summaryContinueBtn.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = t('request_consultation') + ' ';
        }

        // Request consult button text
        const requestConsultBtnText = document.querySelector('.requestConsult__btn .text');
        if (requestConsultBtnText) requestConsultBtnText.textContent = t('request_consultation');

        // Surgical types
        const surgicalSpan = document.querySelector('#button--surgical .title-wrapper__title span');
        if (surgicalSpan) surgicalSpan.textContent = t('surgical');
        const nonSurgicalSpan = document.querySelector('#button--non-surgical .title-wrapper__title span');
        if (nonSurgicalSpan) nonSurgicalSpan.textContent = t('non_surgical');

        // Address screen
        const addressSubtitle = document.querySelector('.address-collection__subtitle');
        if (addressSubtitle) addressSubtitle.textContent = t('address_subtitle');

        // Appointment summary screen
        const confirmTitle = document.querySelector('.confirmation-title');
        if (confirmTitle) confirmTitle.textContent = t('please_confirm_appointment');
        const minuteConsultMsg = document.querySelector('.appointment__banner .message');
        if (minuteConsultMsg) {
            const textNode = Array.from(minuteConsultMsg.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = ' ' + t('minute_consult_required');
        }
        const appointmentDetailsTitle = document.querySelector('.appoitment-details__title');
        if (appointmentDetailsTitle) appointmentDetailsTitle.textContent = t('services');
        const appointmentSummaryConfirmText = document.querySelector('.appointment-summary__continue-btn .text');
        if (appointmentSummaryConfirmText) appointmentSummaryConfirmText.textContent = t('confirm');

        // Card collection screen
        const saveCardText = document.querySelector('.card-collection__continue-btn .text');
        if (saveCardText) saveCardText.textContent = t('save_card_and_confirm');

        // Sign in links
        document.querySelectorAll('#header-sign-in-client-portal, #header-sign-in-client-portal-reschedule').forEach(el => {
            el.textContent = t('sign_in');
        });

        // Appointment confirmed - appointment date
        const appointmentDateTitle = document.querySelector('.appointment-confirmed__datetime-section .title-text');
        if (appointmentDateTitle) appointmentDateTitle.textContent = t('appointment_date');

        // Appointment cancel screen
        const cancelContainerTitle = document.querySelector('.appointment-cancel__container .title__content');
        if (cancelContainerTitle) cancelContainerTitle.textContent = t('appointment_summary_title');
        const cancelledTitle = document.querySelector('.appointment-cancel__container .title.w-100');
        if (cancelledTitle) cancelledTitle.textContent = t('appointment_cancelled_title');

        // Appointment reschedule screens
        [
            ['.appointment-reschedule__container .title__content', 'reschedule_appointment'],
            ['.appointment-reschedule__container .title.w-100', 'reschedule_your_appointment'],
            ['.appointment-reschedule-reason__datetime-section .title.w-100', 'appointment_date'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });
        const currentLabel = document.querySelector('.current-appointment .reschedule-row-label');
        if (currentLabel) currentLabel.textContent = t('current_label');
        const newTimeLabel = document.querySelector('.new-appointment .reschedule-row-label');
        if (newTimeLabel) newTimeLabel.textContent = t('new_time_label');

        // Provider scheduling - available date
        const availableDateSpan = document.querySelector('.providerScheduling__date > span');
        if (availableDateSpan) availableDateSpan.textContent = t('available_date');

        // Service summary - book now
        const bookNowBtn = document.querySelector('.serviceSummary__bookNow');
        if (bookNowBtn) bookNowBtn.textContent = t('book_now');

        // Consult summary screen
        [
            ['.consultSummary__container .title__content', 'consult_summary'],
            ['.consult-summary__btn', 'still_interested_consult'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });

        // Upload photos screen
        [
            ['.uploadPhotos__container .title__content', 'upload_your_photos'],
            ['.uploadPhotosTop__heading-title', 'upload_your_photos'],
            ['.uploadPhotosTop__heading-desc', 'upload_photos_desc'],
            ['.uploadPhotosDesc__title', 'upload_click_or_drag'],
            ['.uploadPhotosDesc__text', 'upload_multiple_files'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });
        const skipStepBtn = document.querySelector('.uploadPhotosContinue__btn');
        if (skipStepBtn) {
            const textNode = Array.from(skipStepBtn.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) textNode.textContent = t('skip_step') + ' ';
        }

        // Gender screen
        const genderScreenTitle = document.querySelector('.gender__container .title__content');
        if (genderScreenTitle) genderScreenTitle.textContent = t('select_your_gender');
        document.querySelectorAll('.select__gender').forEach((btn, i) => {
            btn.textContent = i === 0 ? t('male') : t('female');
        });

        // Body area selection screen
        const bodyAreaTitle = document.querySelector('.bodyAreaSelection__container .title__content');
        if (bodyAreaTitle) bodyAreaTitle.textContent = t('select_problem_areas');

        // Book appointment screens (two instances)
        document.querySelectorAll('.bookAppointment__title').forEach(el => {
            el.textContent = t('book_an_appointment');
        });
        document.querySelectorAll('.bookAppointment__desc').forEach(el => {
            el.textContent = t('click_continue_to_book');
        });

        // All questions screen
        const questionsTitle = document.querySelector('.allQuestions__container .title__content');
        if (questionsTitle) questionsTitle.textContent = t('questions_title');

        // Verify information screen
        [
            ['.verifyInformation__container .title__content', 'verify_information_title'],
            ['.verify-infor__header .title', 'verify_information_subtitle'],
            ['.verify-infor__header .subtitle', 'verify_information_desc'],
            ['.verify-infor-continue__btn .text', 'verify_btn'],
        ].forEach(([sel, key]) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = t(key);
        });

        // Patients screen
        const patientsScreenTitle = document.querySelector('.patients__container .title__content');
        if (patientsScreenTitle) patientsScreenTitle.textContent = t('book_an_appointment');
        const patientScreenSubtitle = document.querySelector('.patient--title');
        if (patientScreenSubtitle) patientScreenSubtitle.textContent = t('are_you_new_patient');

        // Call us screen
        const callUsTitle = document.querySelector('.callus_container .title__content');
        if (callUsTitle) callUsTitle.textContent = t('call_us');
        const callUsSubtitle = document.querySelector('.callus--title');
        if (callUsSubtitle) callUsSubtitle.textContent = t('select_location_to_call');

        // Ask a question screen
        const askQuestionBtn = document.querySelector('.ask-question__btn');
        if (askQuestionBtn) askQuestionBtn.textContent = t('ask_a_question');

        // End screen
        const mainText = document.querySelector('.main-text');
        if (mainText) mainText.textContent = t('thanks');
        const notifyText = document.querySelector('.notify-text');
        if (notifyText) notifyText.textContent = t('message_received');

        // Email checkbox label
        const notifySpecialsSpan = document.querySelector('.emailCheckbox__wrapper > span');
        if (notifySpecialsSpan) notifySpecialsSpan.textContent = t('notify_future_specials');

        // SMS consent aria-labels (both requestConsult and askQuestion sections)
        document.querySelectorAll('.sms-consent-transactional-checkbox').forEach(el =>
            el.setAttribute('aria-label', t('sms_transactional_aria')));
        document.querySelectorAll('.terms-privacy-checkbox').forEach(el =>
            el.setAttribute('aria-label', t('terms_privacy_aria')));
        document.querySelectorAll('.sms-consent-promotional-checkbox').forEach(el =>
            el.setAttribute('aria-label', t('sms_promotional_aria')));
        document.querySelectorAll('.sms-consent-disclaimer').forEach(el => {
            el.textContent = t('sms_disclaimer');
        });

        // SMS transactional label: "I agree to receive... from [Business Name] (e.g. ...)"
        document.querySelectorAll('.sms-consent-transactional-row .sms-consent-label').forEach(el => {
            const nodes = Array.from(el.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = t('sms_transactional_before');
            if (nodes[1]) nodes[1].textContent = t('sms_transactional_after');
        });

        // SMS promotional label: "I agree to receive... from [Business Name]."
        document.querySelectorAll('.sms-consent-promotional-row .sms-consent-label').forEach(el => {
            const nodes = Array.from(el.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = t('sms_promotional_before');
            if (nodes[1]) nodes[1].textContent = t('sms_promotional_after');
        });

        // Terms & privacy label: "I accept the [Terms] and [Privacy Policy]."
        document.querySelectorAll('.terms-privacy-label').forEach(el => {
            const nodes = Array.from(el.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = t('terms_privacy_before');
            if (nodes[1]) nodes[1].textContent = t('terms_privacy_mid');
            if (nodes[2]) nodes[2].textContent = t('terms_privacy_after');
            const termsLink = el.querySelector('.terms-link');
            if (termsLink) termsLink.textContent = t('terms_and_conditions');
            const privacyLink = el.querySelector('.privacy-link');
            if (privacyLink) privacyLink.textContent = t('privacy_policy');
        });

        // Passive consent: "By continuing, you consent to receive... from [Business Name]. Msg & data rates..."
        document.querySelectorAll('.sms-consent-passive-text').forEach(el => {
            const nodes = Array.from(el.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
            if (nodes[0]) nodes[0].textContent = t('sms_passive_before');
            if (nodes[1]) nodes[1].textContent = t('sms_passive_after');
        });
    }

    loadData(form.data);
    if (Object.values(form.data.procedures).length > 0) {
        setOriginProcedures(Object.values(form.data.procedures));
        setProcedures(Object.values(form.data.procedures));
    }

    const thankYouMessage = form.data.thank_you_message || form.data.appointment_channel?.thank_you_message;
    if (thankYouMessage) {
        document.querySelector('.notify-text').innerHTML = thankYouMessage;
    }

    if (form.data.custom_script) {
        injectScriptFromString(form.data.custom_script);
    }

    if (form.data.thank_you_redirect_url) {
        setRedirectUrl(form.data.thank_you_redirect_url);
    }

    if (form.data.appointment_channel?.redirect_url) {
        setCalendarRedirectUrl(form.data.appointment_channel.redirect_url);
    }

    if (form.data.hide_powered_by || projectWhitelabel) {
        document.querySelectorAll('.subFooter--4').forEach((i) => {
            i.innerHTML = '';
        });
    }

    // Disable the search service
    setIsDisableSearchService(form?.data?.disable_search_service);

    setIsHideServiceDuration(form?.data?.hide_service_duration ?? false);

    setCategories(form.data.service_categories);

    /* Check width of screen is mobile */
    if (params('mobile')) {
        document
            .querySelector('.assistant__iframe')
            .classList.add('mobile-ver');
    }

    /* Check width of screen is desktop */
    if (params('desktop')) {
        document
            .querySelector('.assistant__iframe')
            .classList.add('desktop-ver');

        setIsDesktopVer(true)
    }

    // Check if in iframe
    if (params('in_iframe')) {
        setInitUI('embedded')
    }

    /* Check scheduling link */
    if (params('appointment_channel_id')) {
        document
            .querySelector('.assistant__iframe')
            .classList.add('scheduling-link');
    }

    // Square chrome only on the PilotPractice Marketing Intro booker
    // (channel 441). Do not flatten any other widget or scheduling link.
    if (String(params('appointment_channel_id')) === '441') {
        document
            .querySelector('.assistant__iframe')
            .classList.add('square-corners');
    }

    /* Check scheduling link */
    if (params('appointment_channel_for_floater')) {
        document
            .querySelector('.assistant__iframe')
            .classList.add('appointment_channel_for_floater');
    }

    pagesDom.push(document.querySelector('.mainMenu__container'));

    // Add icon background color
    document.querySelectorAll('.icon__background').forEach((element) => {
        element.style.background = `${primaryColor}0f`;
    });

    if (params('modal-popup')) {
        setIsModalPopup(true);
    }
    const isOpen = (params(FULL_PAGE) && params('procedure_id') && params('staff_id')) || params(APPOINTMENT_CHANNEL_ID)
    if (isOpen) {
        toggleLoading(true);
        openBookAppointment();
    }

    if (buttonTriggered) {
        openWidgetFromButtonTrigger(buttonTriggered);
    }

    if (params(UPLOAD_ID_PARAM)) {
        loadUploadPhotosLandingPage();
    } else if (params(EVENT_ID_PARAM)) {
        await loadAppoinmentConfirmedLandingPage();
    } else if (params(ESTIMATE_ID_PARAM)) {
        await loadInstantQuoteSummaryLandingPage();
    } else if (params(BOOK_APPOINTMENT_PARAM)) {
        const leadId = params('lead_id');
        const signature = params('signature');
        const expires = params('expires');
        const dropoffOtpResume = params(DROPOFF_RESUME_PARAM) === 'after_otp' && leadId && signature && expires;
        if (dropoffOtpResume) {
            try {
                const res = await getLeadResumeToken(leadId, signature, expires);
                const data = res?.data ?? res;
                if (data?.access_token) setAccessToken(data.access_token);
                if (data?.lead) setLeadInfo(data.lead);
            } catch (_) {
                // Link invalid or expired; continue without auto-login
            }
        }
        if (isModalPopup) {
            bookAppointmentListeners();
        } else {
            openBookAppointment();
        }

        postVisitor();
        loadComponents();
        listeners();
    } else {
        handleInstantQuoteSummary();
        postVisitor();
        loadComponents();
        listeners();
        if (
            (params(IGNORE_IFRAME) && params(ESTIMATE))
        ) {
            document.getElementById('instant_quote')?.click();
            document.querySelector(
                '.providers__container .providerBack__btn'
            ).style.visibility = 'hidden';
        }
    }
    if (parent) {
        parent.postMessage(EVENT_MESSAGE.FINISH_LOADING_IFRAME, '*');
    }
    applyDisclaimerFooters();
};

window.addEventListener('message', ({ data }) => {
    if (data && typeof data === 'string' && data.startsWith('navigate')) {
        buttonTriggered = extractMessageKey(data);
    }
});

const extractMessageKey = (message) => message.replace('navigate', '').trim();

/**
 * When widget runs inside assistant.pilotpractice.com iframe, the embedding page
 * (e.g. zarrabimd.com) passes source/domain/path so we can attribute the visitor
 * to the real site instead of the iframe URL. Returns { domain, path, referrer } for the
 * embedding page when available.
 */
function getEmbeddingPageAttribution() {
    const sourceParamVal = params('source');
    const domainParamVal = params('domain');
    const pathParamVal = params('path');
    const isAssistantIframe = /assistant\.pilotpractice\.com/i.test(window.location.hostname);
    if (!isAssistantIframe || (!sourceParamVal && !(domainParamVal && pathParamVal))) {
        return null;
    }
    let pageUrl = null;
    if (sourceParamVal && (sourceParamVal.startsWith('http://') || sourceParamVal.startsWith('https://'))) {
        pageUrl = sourceParamVal.split('#')[0];
    } else if (domainParamVal && pathParamVal) {
        const path = pathParamVal.startsWith('/') ? pathParamVal : '/' + pathParamVal;
        const domain = domainParamVal.replace(/^https?:\/\//, '').split('/')[0];
        pageUrl = `https://${domain}${path}`;
    }
    if (!pageUrl) return null;
    try {
        const u = new URL(pageUrl);
        return {
            domain: u.hostname,
            path: u.pathname || '/',
            referrer: pageUrl,
        };
    } catch (_) {
        return null;
    }
}

/** Get a query param from a URL string (e.g. referrer). Returns null if URL is invalid or param missing. */
function paramFromUrl(urlString, paramName) {
    if (!urlString || typeof urlString !== 'string') return null;
    try {
        const url = new URL(urlString);
        return url.searchParams.get(paramName);
    } catch {
        return null;
    }
}

async function postVisitor() {
    const embedding = getEmbeddingPageAttribution();
    let visitorPayload = {
        domain: window.location.hostname,
        path: window.location.pathname + window.location.search,
        referrer: document.referrer || '',
    };
    if (embedding) {
        visitorPayload.domain = embedding.domain;
        visitorPayload.path = embedding.path;
        visitorPayload.referrer = embedding.referrer;
    }

    const referrerUrl = visitorPayload.referrer || '';
    // Prefer current URL params, fall back to referrer (so we capture gclid/gbraid/wbraid when they're only in the referrer).
    const get = (name) => params(name) || paramFromUrl(referrerUrl, name);

    // Send paid_ad_click when we have click IDs OR our tracking source (google-ads-*, meta-ads-*) so number swap works for all ad visitors.
    // Include gbraid/wbraid so iOS (and other browsers that send braid instead of gclid) get captured and conversions can be sent to Google.
    const sourceVal = get('source') || '';
    const isOurAdSource = /^(google-ads-|meta-ads-)/i.test(sourceVal.trim());
    if (get('gclid') || get('fbclid') || get('gbraid') || get('wbraid') || get('oppref') || isOurAdSource) {
        visitorPayload['paid_ad_click'] = {
            ...(get('gclid') && { gclid: get('gclid') }),
            ...(get('fbclid') && { fbclid: get('fbclid') }),
            ...(get('oppref') && { oppref: get('oppref') }),
            ...(get('utm_medium') && { utm_medium: get('utm_medium') }),
            ...(get('utm_source') && { utm_source: get('utm_source') }),
            ...(get('utm_campaign') && { utm_campaign: get('utm_campaign') }),
            ...(get('utm_network') && { utm_network: get('utm_network') }),
            ...(get('gbraid') && { gbraid: get('gbraid') }),
            ...(get('wbraid') && { wbraid: get('wbraid') }),
            ...(sourceVal && { source: sourceVal }),
        };
    }

    const response = await createVisitor(visitorPayload);

    if (response.data) {
        setVisitorId(response.data.id);
        window.visitor_id = response.data.id;
    }
}

function loadComponents() {
    document
        .querySelector('.main__logo')
        .setAttribute('src', form.project.business_photo);

    if (form.project.business_photo) {
        document
            .querySelector('.appointment__logo')
            .setAttribute('src', form.project.business_photo);
    }
    onLoadOption();

    loadInstantQuotes();

    loadRequestConsultComponents();

    loadAskQuestionComponents();

    // loadProcedures(procedures);

    // loadCategories(procedures);
    const shouldCollectPatientInfoFirst = form?.appointment_channel?.collect_patient_information_first_before_scheduling;
    const pros = (appointmentChannelId && shouldCollectPatientInfoFirst) ? form?.appointment_channel?.procedures : procedures;
    loadSelectSearchProcedure(pros);

    loadLocationList();
    loadInterestList();

    if (providers.length > 1) {
        loadProvidersDropdown(providers);
    }
    if (locations.length > 0) {
        loadLocationsDropdown(locations);
    }

    loadSurgicalList();
}

function canUserChooseStaff(hostType, staffCount) {
    switch (hostType) {
        case HOST_TYPE_ONE_ON_ONE:
            return staffCount > 1;
        case HOST_TYPE_ROUND_ROBIN:
        case HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return form?.appointment_channel?.visitor_can_choose_the_staff;
    }
}

function getHostType() {
    return form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
}

function listeners() {
    // Drop-off session watch: tab hidden 15s / page unload → end session now
    // instead of waiting for the backend's 5-minute idle sweep.
    initSessionWatch();

    pageListeners();

    filterCategory();

    scheduleListeners();

    askQuestionListeners();

    setLoadingColor(primaryColor);
    if (locations.length > 0) {
        locationListeners();
    }
    interestListeners();
    fullNameListeners();
    emailListeners();
    // Booking-path contact prefill (URL params from marketing handoffs like
    // kloudmd.com/get-started). Must run AFTER fullNameListeners/emailListeners
    // assign the oninput validators, and must dispatch 'input' so validation
    // runs and the screen's Continue button enables. Values set via .value are
    // inert as HTML; urlPrefill sanitizes on parse.
    [['#fullName', urlPrefill.full_name], ['#email', urlPrefill.email]].forEach(([sel, val]) => {
        const el = document.querySelector(sel);
        if (el && !el.value && val) {
            el.value = val;
            el.dispatchEvent(new Event('input', { bubbles: true }));
        }
    });
    validateDigitsListeners();
    footerListeners();
    instantQuoteSummaryListeners();
    consultSchedulingListeners();
    surgicalListeners();
    // Listen to messages from parent window
    bindEvent(window, 'message', function (e) {
        let message = e.data;
        if (message && message === UPDATE_APPOINTMENT_CHANNEL) {
            getFormByFormId(formId, appointmentChannelId).then((data) => {
                setForm(data.data)
                openBookAppointment()

            }).catch((error) => {
            });
        }
        if (message && typeof message === 'string') {
            if (message.includes('redirect')) {
                window.parent.location.href = message.substring(8);
            }
            if (message.includes('navigate')) {
                message = message.substring(8);
                // document
                //     .querySelectorAll('.screen:not(.mainMenu__container)')
                //     .forEach((i) => i.classList.remove('show-screen'));
            }

            switch (message) {
                case EVENT_MESSAGE.REFRESH:
                    // Parent closes the widget bubble → REFRESH. Start the
                    // 15s drop-off grace timer (cancelled on reopen).
                    sessionWatchWidgetClosed();
                    refresh();
                    break;
                case EVENT_MESSAGE.INSTANT_QUOTE:
                    openInstantQuote();
                    break;
                case EVENT_MESSAGE.REQUEST_CONSULT:
                    openScheduleConsultation();
                    break;
                case EVENT_MESSAGE.ASK_QUESTION:
                    openAskQuestion();
                    break;
                case EVENT_MESSAGE.TEXT_US:
                    navigate(SCREEN.ASK_QUESTION);
                    break;
                case EVENT_MESSAGE.FINISH_LOADING:
                    toggleLoadingIframe(HIDE);
                    break;
                case EVENT_MESSAGE.BOOK_APPOINTMENT:
                    bookAppointmentListeners();
                    openBookAppointment();
                    break;
                case EVENT_MESSAGE.TOGGLE_WIDGET:
                    applyDisclaimerFooters();

                    if (appointmentChannelId && !shouldCollectPatientInfoFirstForWidget) {
                        openBookAppointment();
                    }
                    break;
                case EVENT_MESSAGE.OPEN_BOOK_APPOINTMENT_FLOW:
                    openBookAppointment();
                    break;
                case EVENT_MESSAGE.WIDGET_OPEN:
                    // Widget reopened → cancel any pending drop-off timer.
                    sessionWatchWidgetOpened();
                    if (visitorId) {
                        updateVisitorAction(visitorId, 'view-widget', {
                            widget_type: 'Open Assistant'
                        }).catch(error => {
                            console.error('Failed to track assistant widget open:', error);
                        });
                    }
                    break;
                default:
                    break;
            }
        }
    });

    /* on click Continue after select procedure */
    document
        .querySelector('.procedureContinue__btn')
        .addEventListener('click', async () => {
            const isConsultationRequest = form.appointment_request_type === APPOINTMENT_REQUEST_FORM;
            if (isConsultationRequest && form?.is_category_enabled && (tempLeadInfo || leadInfo) && selectedProcedures.length > 0) {
                let loaderIcon = document.querySelector('.procedureContinue__btn .loader__icon');
                try {
                    document.querySelector('.procedureContinue__btn')?.classList.add('disabled');
                    document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.remove('hidden');
                    if (loaderIcon) {
                        loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
                    }
                    toggleLoading(true);
                    
                    const data = {
                        ...tempLeadInfo,
                        procedures_interested_in: selectedProcedures,
                    };
                    
                    const selectedProcedureNames = selectedProcedures
                        .map((id) => procedures.find((item) => item?.id === id)?.name)
                        .filter(Boolean);
                    const serviceValue = selectedProcedureNames.join(', ');
                    if (serviceValue) {
                        const lastFormSubmission = {
                            ...(data.last_form_submission || {}),
                        };
                        const existingFields = Array.isArray(lastFormSubmission.fields)
                            ? lastFormSubmission.fields
                            : [];
                        const serviceIndex = existingFields.findIndex(
                            (field) =>
                                field?.name === 'service' ||
                                field?.label?.toLowerCase() === 'service'
                        );
                        const nextFields = [...existingFields];
                        if (serviceIndex >= 0) {
                            nextFields[serviceIndex] = {
                                ...nextFields[serviceIndex],
                                value: serviceValue,
                            };
                        } else {
                            nextFields.push({
                                name: 'service',
                                label: 'Service',
                                value: serviceValue,
                                placeholder: '',
                            });
                        }
                        lastFormSubmission.fields = nextFields;
                        data.last_form_submission = lastFormSubmission;
                    }
                    
                    setTempLeadInfo(data);
                    toggleLoading(false);
                    setIsInstantQuote(false);
                    
                    const ids = form?.appointment_channel?.staffs?.map(i => i.id)

                    let listProvider = providers.filter(
                        (provider) => ids.includes(provider.id)
                    )

                    if (selectedProcedures.length > 0) {
                        let res = await getProceduresStaffByProcedureIds(
                            selectedProcedures
                        );
                        setStaffProcedures(res?.data?.data || []);
                        const staffProcedures = res?.data?.data || [];

                        const staffAllowedIds = new Set(
                            staffProcedures.map(sp => sp.staff_id)
                        );

                        listProvider = listProvider.filter(
                            p => staffAllowedIds.has(p.id)
                        );
                    }

                    listProvider = listProvider.filter(
                        (provider) => provider.location_ids?.includes(locationId)
                    )
                    loadProviderList(listProvider)
                    document
                        .querySelector('.providers__container')
                        ?.classList?.add('provider-in-booking');
                    renderContinueBtn();
                    providerListeners();
                    if (appointmentChannelId) {
                        document.querySelector('.providers__container .providerContinue__btn ')?.classList?.add('hide');
                    }
                    navigate(SCREEN.PROVIDERS);
                    // handelConsultSummaryBtn();
                } catch (error) {
                    console.log(error);
                    toastError(error.response?.data?.message);
                    toggleLoading(false);
                } finally {
                    setTimeout(() => {
                        if (loaderIcon) {
                            loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
                        }
                        document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.add('hidden');
                        document.querySelector('.procedureContinue__btn')?.classList.remove('disabled');
                    }, 400);
                }
                return;
            }
            
            if (isInInstantQuote) {
                if (skipInterestPage) {
                    navigate(SCREEN.FULL_NAME);
                    setTimeout(() => {
                        const fullNameInput = document.getElementById('fullName');
                        if (fullNameInput !== document.activeElement) {
                            fullNameInput.focus();
                        }
                    }, 500);
                } else {
                    navigate(SCREEN.INTERESTS);
                }
            } else if (isBookAppointment) {
                let loaderIcon = document.querySelector('.procedureContinue__btn .loader__icon');
                try {
                    document.querySelector('.procedureContinue__btn')?.classList.add('disabled');
                    document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.remove('hidden');
                    if (loaderIcon) {
                        loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
                    }
                    const hostType = getHostType();
                    const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
                    const staffCount = staffsOfAppointmentChannel?.length || 0;
                    // Auto-select soonest provider: ignore provider-first so the flow
                    // routes through handleLocationPage, which skips the picker and
                    // engages the "any provider" (-1) path.
                    const isProviderFirst = form?.appointment_channel?.is_select_provider_first && !isAutoSelectSoonestProviderEnabled();
                    const canChooseStaff = canUserChooseStaff(hostType, staffCount);

                    if ((staffId || (appointmentChannelId && canChooseStaff && providerId)) && isProviderFirst) {
                        const foundProvider = providers?.find(i => i?.id === +staffId)
                        const getLocationId = foundProvider?.location_ids?.includes(selectedLocation) || foundProvider?.location_ids[0]
                        if (!selectedLocation) {
                            setSelectedLocation(getLocationId)
                        }
                        if (appointmentChannelId && canChooseStaff && !providerId) {
                            handleSelectProvider(null, +staffId || foundProvider?.id);

                        }
                        if (canChooseStaff && form?.appointment_channel?.procedures?.length > 1 && !selectedProcedures.length) {
                            const enableCategorySelection = form?.appointment_channel?.enable_category_selection;

                            if (enableCategorySelection) {
                                handleProviderContinueBtn();
                            } else {
                                loadCategories(form?.appointment_channel?.procedures);
                                loadProcedures(form?.appointment_channel?.procedures);
                                navigate(SCREEN.SEE_ALL_SERVICES);
                            }
                        } else {
                            handleProviderContinueBtn()
                        }
                    } else {
                        if (selectedProcedures.length > 0) {
                            let res = await getProceduresStaffByProcedureIds(
                                selectedProcedures
                            );
                            setStaffProcedures(res?.data?.data || []);
                        }

                        let locationId = form?.appointment_channel?.location?.id ?? locations[0]?.id

                        if (!isProviderFirst && selectedLocation) {
                            locationId = selectedLocation
                        }

                        if (locations?.length === 1 || locationId) {
                            setSelectedLocation(locationId);
                            handleLocationPage();
                        } else {
                            navigate(SCREEN.LOCATIONS);
                        }
                        document
                            .querySelector('.no-preference-provider')
                            ?.classList?.remove('hidden');
                    }

                } catch (error) {
                    toastError(error.response?.data?.message);
                } finally {
                    setTimeout(() => {

                        if (loaderIcon) {
                            loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
                        }
                        document.querySelector('.procedureContinue__btn .loading__wrapper')?.classList.add('hidden');

                        document.querySelector('.procedureContinue__btn')?.classList.remove('disabled');
                    }, 400);

                }
            }
        });
}

function loadData(form) {
    setForm(form);

    setFormId(form.uuid);

    setAccessToken(form.token);

    setTooltip(form.title_tooltip);

    setPicture(form.picture);

    setPhoneToCall(form.project.business_phone);

    setWidgetOptions(form.widget_options);

    setFileUploadChannel(form.file_upload_channel);

    setProcedureSelectionType(
        form?.appointment_channel?.selection_type || form.selection_type
    );

    setFinancing(form.quote_settings?.financing_terms);

    setHidePricing(form.quote_settings?.hide_pricing);

    setSkipInterestPage(!!form.quote_settings?.skip_interest_page);

    setHideFutureSpecialsOptIn(!!form.quote_settings?.hide_future_specials_opt_in);

    setShowBodyAreaSelection(form.show_body_area_selection);

    setLocations(form.locations);
    if (form?.hide_widget || form.hide_widget === 0) {
        /* Send `message` to the parent */
        const data = {
            hide_widget: form.hide_widget,
            type: HIDE_WIDGET,
        };
        parent.postMessage(data, '*');
    }

    if (form?.locations && form.locations[0] && form.locations[0]?.project_id) {
        setProjectId(form.locations[0].project_id)
    }

    setShowSubscribedToOffersOption(form.show_subscribed_to_offers_option)
    setA2pConsentEnabled(form.a2p_consent_enabled ?? false);

    setShowMaleFemalePage(form.show_male_female_page);
    setConsultationNonSurgicalPath(form.consultation_non_surgical_path);
    setBusinessName(form.project.business_name);

    // Apply custom consult labels if configured
    if (form.consult_header_title) {
        const headerEl = document.querySelector('.requestConsult__container .title__content');
        if (headerEl) headerEl.textContent = form.consult_header_title;
    }
    if (form.consult_button_label) {
        document.querySelectorAll('.requestConsult__btn .text, .summaryContinue__btn').forEach(el => {
            if (el.classList.contains('text')) {
                el.textContent = form.consult_button_label;
            } else if (el.classList.contains('summaryContinue__btn')) {
                // Preserve the loader icon inside the button
                const loader = el.querySelector('.loader__icon');
                el.textContent = form.consult_button_label + ' ';
                if (loader) el.appendChild(loader);
            }
        });
    }
    setInterests([
        {
            id: 1,
            name: t('interest_just_curious'),
            value: 'just_curious',
        },
        {
            id: 2,
            name: t('interest_as_soon_as_possible'),
            value: 'immediately',
        },
        {
            id: 3,
            name: t('interest_few_months'),
            value: 'few_months',
        },
    ]);

    if (Object.values(form.staff)?.length > 0) {
        let staffs = form.staff ?? [];
        const sortedStaff = (staffs || []).sort((a, b) => Number(a?.order) - Number(b?.order));

        setProviders(Object.values(sortedStaff));
        setOriginProviders(Object.values(sortedStaff));
    }

    if (form.widget_options.length > 0) {
        let widgetOptions = [];
        let widgetCustomOptions = [];
        form.widget_options.forEach(function (option) {
            switch (option.type) {
                case 'instant_quote':
                    widgetOptions.push('instant_quote');
                    setOptionNames('instant_quote', option.name !== tDefault('instant_quote') ? option.name : t('instant_quote'));
                    setOptionIcons(
                        'instant_quote',
                        option?.icon && option.icon.name
                    );
                    break;
                case 'ask_a_question':
                    widgetOptions.push('ask_a_question');
                    setOptionNames('ask_a_question', option.name !== tDefault('ask_question') ? option.name : t('ask_question'));
                    setOptionIcons(
                        'ask_a_question',
                        option?.icon && option.icon.name
                    );
                    break;
                case 'call_us':
                    widgetOptions.push('call');
                    setOptionNames('call', option.name !== tDefault('call_us') ? option.name : t('call_us'));
                    setOptionIcons('call', option?.icon && option.icon.name);
                    break;
                case 'text_us':
                    widgetOptions.push('text_us');
                    setOptionNames('text_us', option.name !== tDefault('text_us') ? option.name : t('text_us'));
                    setOptionIcons('text_us', option?.icon && option.icon.name);
                    break;
                case 'schedule_consultation':
                case 'request_consultation':
                case 'book_appointment':
                    widgetOptions.push('book_appointment');
                    setOptionNames('book_appointment', option.name !== tDefault('book_appointment') ? option.name : t('book_appointment'));
                    setOptionIcons(
                        'book_appointment',
                        option?.icon && option.icon.name
                    );
                    break;
                case 'faqs':
                    /* Deprecated: skip FAQs option so it does not appear in the widget menu */
                    break;
                default:
                    setOptionNames(`custom_option-${option.id}`, option.name);
                    setOptionIcons(
                        `custom_option-${option.id}`,
                        option?.icon && option.icon.name
                    );
                    widgetCustomOptions.push(`custom_option-${option.id}`);
                    break;
            }
        });
        setWebAssistantOptions(
            [...widgetOptions, ...widgetCustomOptions].sort(
                (a, b) => a.id - b.id
            )
        );
    }
}

const injectScriptFromString = (scriptString) => {
    if (!scriptString) return;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = scriptString;

    const scripts = tempDiv.querySelectorAll('script');

    scripts.forEach(script => {
        const scriptElement = document.createElement('script');

        if (script.src) {
            scriptElement.src = script.src;
            scriptElement.async = script.async;
        } else {
            scriptElement.text = script.textContent;
        }

        document.head.appendChild(scriptElement);
    });
}

function openWidgetFromButtonTrigger(buttonType = "") {
    switch (buttonType) {
        case EVENT_MESSAGE.INSTANT_QUOTE:
            openInstantQuote();
            break;
        case EVENT_MESSAGE.REQUEST_CONSULT:
            openScheduleConsultation();
            break;
        case EVENT_MESSAGE.ASK_QUESTION:
            openAskQuestion();
            break;
        case EVENT_MESSAGE.TEXT_US:
            navigate(SCREEN.ASK_QUESTION);
            break;
        case EVENT_MESSAGE.BOOK_APPOINTMENT:
            openBookAppointment();
            break;
        default:
            break;
    }

}
